<script lang="ts">
	import { nbspify } from "../../../../core/utils/nbspify";
	import type { CakeProps } from "../../templates/WeddingsProps";
	import StaticPicture from "../Picture/StaticPicture.svelte";

	export let index: number;
	export let cake: CakeProps;
</script>

<div class="glide__slide group relative flex flex-col items-center gap-6 min-[500px]:items-start">
	<div class="relative h-[16.5rem] w-[13.5rem] rounded-lg lg:h-[22.5rem] lg:w-[18rem]">
		<div
			class="absolute left-4 top-4 flex h-6 w-6 items-center justify-center rounded-full bg-white text-base font-semibold lg:h-8 lg:w-8 lg:text-md"
		>
			{index + 1}
		</div>
		<StaticPicture
			class="h-full w-full overflow-hidden rounded-lg"
			image={cake.image}
			alt={cake.alt ?? "Fotografie – ukázka svatebního dortu"}
			height={360}
			width={288}
			loading="lazy"
		/>
	</div>
	<div class="max-w-[13.5rem] min-[500px]:max-w-[initial]">
		{#each cake.desc as desc}
			<p class="whitespace-normal">{nbspify(desc)}</p>
		{/each}
	</div>
</div>
